import React, { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { canAccessPath, getDefaultRoute } from "@/lib/permissions";

/**
 * Redirects users who navigate to a route their role cannot access.
 */
export default function PermissionGate({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = user?.permissions || [];

  useEffect(() => {
    if (loading || !user) return;
    if (!canAccessPath(location.pathname, permissions)) {
      navigate(getDefaultRoute(permissions), { replace: true });
    }
  }, [loading, user, location.pathname, permissions, navigate]);

  if (loading) {
    return (
      <div className="h-screen grid place-items-center bg-[#F8FAFC] text-[13px] text-slate-500">
        Loading…
      </div>
    );
  }

  if (!user) return null;

  if (!canAccessPath(location.pathname, permissions)) {
    return <Navigate to={getDefaultRoute(permissions)} replace />;
  }

  return children;
}
